import * as React from "react";
import { ColorResult, SketchPicker } from "react-color";

import "./ColorSwatch.scss";

interface Props {
  position?: "left" | "right";
  color?: string;
  name: string;
  onColorChange?: (name: string, color: string) => void;
  className?: string;
}
interface State {
  isShowingPicker: boolean;
}

export class ColorSwatch extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { isShowingPicker: false };
    this.handleClick = this.handleClick.bind(this);
    this.hidePicker = this.hidePicker.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  handleClick() {
    this.setState({ isShowingPicker: !this.state.isShowingPicker });
  }
  hidePicker() {
    this.setState({ isShowingPicker: false });
  }
  handleChange(color: ColorResult, event: React.ChangeEvent<HTMLInputElement>) {
    if (this.props.onColorChange) {
      this.props.onColorChange(this.props.name, color.hex);
    }
  }
  render() {
    let className = this.state.isShowingPicker ? "ssColorSwatch ssColorSwatchIsShowing" : "ssColorSwatch";

    if (this.props.className) {
      className += " " + this.props.className;
    }

    const popoverStyle = {
      position: "absolute",
      zIndex: "1000",
      top: "19px",
      left: this.props.position && this.props.position == "left" ? "30px" : "30px",
      right: this.props.position && this.props.position == "right" ? 0 : "auto"
      //(this.props.position && this.props.position == "right") ? {  right: 0} : { left: 100 }
    };
    const wrapperStyle = {
      background: this.props.color
    };
    // const picker = (!this.state.isShowingPicker) ? null : <SketchPicker color={this.state.color} disableAlpha={true} onChange={ this.handleChange }/>;
    // const cover =  (!this.state.isShowingPicker) ? null : <div className="ssColorSwatchCover" onClick={ this.handleClose }/>;
    return (
      <div className={className}>
        <div className="ssColorSwatchWrapper" style={wrapperStyle}>
          {this.props.onColorChange && <div className="ssColorSwatchButton" onClick={this.handleClick} />}
        </div>

        {this.state.isShowingPicker ? (
          <div style={popoverStyle as any} className="ssColorSwatchPopover">
            <div className="ssColorSwatchCover" onClick={this.hidePicker} />
            <SketchPicker color={this.props.color} disableAlpha={true} onChange={this.handleChange} />
          </div>
        ) : null}
      </div>
    );
  }
}
